import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { LocationService } from './location.service';
import { ItemData } from '../models/item-data';
import { TransportPlanData } from '../models/transport-plan-data';
import { AError } from '../models/aerror';

@Injectable({
  providedIn: 'root'
})
export class TransportPlanService {

  constructor(private api: ApiService,
              private locationService: LocationService) {
  }

  scanItemTransportPlan(barcode: string): Promise<[ItemData, TransportPlanData]> {
    if (!barcode) {
      return Promise.reject(AError.fromSomeError('Barcode is required to scan item transport plan!'));
    }
    const currentLocation = this.locationService.currentLocation;
    return this.api.scanItemTransportPlan(barcode, currentLocation);
  }
}
